<div class="update-bar">
    <p>{{ 'newVersion' | translate }}</p>

    <div class="buttons-wrapper">
        <button uiButton variant="default" size="sm"
                [loading]="isUpdating"
                (click)="update()">
            <i uiPrefix class="fa-solid fa-rotate-right" aria-hidden="true"></i>
            {{ 'refresh' | translate }}
        </button>

        <button uiButton variant="ghost" size="icon"
                [attr.aria-label]="'close' | translate"
                (click)="close()">
            <i class="fas fa-times" aria-hidden="true"></i>
        </button>
    </div>
</div>
